import dayjs from "dayjs"
import { ISubmitReadings } from "./MeterReadingsMutator.types"
import { isServerError } from "@/api/utils/HttpClient"
import { isBackofficeApiError } from "@/api/backofficeRest/backofficeApiError"

const DAYS_TO_WAIT_FOR_METER_DETAILS = 31

export class SubmitReadingsError extends Error {
  messages: string[]

  constructor(messages: string[], message: string) {
    super(message)
    this.messages = messages
  }
}

type ReadingServerErrorResponse = {
  errors: string[]
}

function buildSubmitReadingsError(
  submissionErrorMessages: string[],
  { meterpoint, account, date }: ISubmitReadings,
) {
  const isNearSsd =
    Math.abs(dayjs().diff(meterpoint.supplyStartDate, "days", false)) <
    DAYS_TO_WAIT_FOR_METER_DETAILS

  if (isNearSsd) {
    submissionErrorMessages.push(
      "This is a new So Energy customer, we may not have the correct meter technical details yet. It is best to try again in 7 days. If the reading is still not been accepted, escalate this contact to SCOA.",
    )
  }

  const isReadingDatedAfterCloseDate =
    account.endDate && dayjs(date).isAfter(account.endDate)

  if (isReadingDatedAfterCloseDate) {
    submissionErrorMessages.push(
      "The read you’re trying to submit is outside of the account supply dates. Double check the date of the reading with the customer and try again.",
    )
  }

  return new SubmitReadingsError(
    submissionErrorMessages,
    `Read submission for ${meterpoint.identifier} failed`,
  )
}

export function processReadingErrors(error: Error, data: ISubmitReadings) {
  if (isBackofficeApiError(error)) {
    return buildSubmitReadingsError([error.userMessage], data)
  }

  if (!isServerError<ReadingServerErrorResponse>(error)) return

  return buildSubmitReadingsError(error.response?.data?.errors || [], data)
}
